import { render } from "./HeroSet2.vue?vue&type=template&id=180e6a3e&scoped=true"
import script from "./HeroSet2.vue?vue&type=script&lang=js"
export * from "./HeroSet2.vue?vue&type=script&lang=js"

import "./HeroSet2.vue?vue&type=style&index=0&id=180e6a3e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-180e6a3e"

export default script